export default __webpack_public_path__ + "static/wave-c2cb9d43a8da95f163f12ee086130c7d.png";